// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9b6766e8","732":"7e11096f","977":"acea426a"}[chunkId] + ".chunk.js";
};